<script>
  import { Meteor } from 'meteor/meteor';
  import { Tracker } from 'meteor/tracker';
  import { onMount } from 'svelte';
  import { ContactsCollection } from '../../../api/contacts/contacts';
  import LeadNotesCell from '../../components/mgmt/LeadNotesCell.svelte';
  import LeadNotesRow from '../../components/mgmt/LeadNotesRow.svelte';
  import LeadStatusActions from '../../components/mgmt/LeadStatusActions.svelte';
  import { sortedNotes } from './leadHelpers';
  import { callMethod } from './managementMethods';

  let { onActionMessage = () => {} } = $props();

  let contacts = $state([]);
  let expandedNotesId = $state('');

  onMount(() => {
    const contactsSub = Meteor.subscribe('mgmt.leads.contacts');
    const computation = Tracker.autorun(() => {
      contacts = ContactsCollection.find({}, { sort: { createdAt: -1 } }).fetch();
    });

    return () => {
      computation.stop();
      contactsSub.stop();
    };
  });

  function toggleNotes(entryId) {
    expandedNotesId = expandedNotesId === entryId ? '' : entryId;
  }

  async function updateLeadStatus(kind, id, status) {
    const note = prompt('Add note (required for status update):', 'Status updated by management');
    if (!note) return;

    try {
      await callMethod('contacts.updateStatus', { contactId: id, status, note });
    } catch (error) {
      onActionMessage(error.reason || 'Lead status update failed.');
    }
  }

  async function removeClosedLead(lead) {
    if (!confirm(`Remove ${lead.fullName} from contact leads? This cannot be undone.`)) return;

    try {
      await callMethod('contacts.removeClosed', { contactId: lead._id });
      onActionMessage('Contact lead removed.');
      if (expandedNotesId === lead._id) expandedNotesId = '';
    } catch (error) {
      onActionMessage(error.reason || 'Could not remove contact lead.');
    }
  }
</script>

<div class="management-section">
  <h2>Contact Leads</h2>
  <table class="lead-table">
    <thead>
      <tr><th>Name</th><th>Contact</th><th>Interest</th><th>Status</th><th>Notes</th><th>Actions</th></tr>
    </thead>
    <tbody>
      {#each contacts as lead (lead._id)}
        {@const notes = sortedNotes(lead)}
        <tr>
          <td>
            <strong>{lead.fullName}</strong>
            <p class="lead-detail">{lead.createdAt?.toLocaleString?.([Meteor.settings.public.locale], Meteor.settings.public.datestamp) || '-'}</p>
          </td>
          <td>
            <a href={`mailto:${lead.emailAddress}`}>{lead.emailAddress}</a>
            <p class="lead-detail">{lead.phoneNumber || '-'}</p>
          </td>
          <td>
            {lead.interestedVehicle || '-'}
            <p class="lead-message">{lead.message}</p>
          </td>
          <td class="status-cell">
            <span>{lead.status}</span>
            {#if lead.status === 'closed'}
              <button
                type="button"
                class="danger-btn status-remove-btn"
                aria-label={`Remove ${lead.fullName}`}
                title="Remove closed lead"
                onclick={() => removeClosedLead(lead)}
              >
                X
              </button>
            {/if}
          </td>
          <td>
            <LeadNotesCell
              entryId={lead._id}
              {notes}
              {expandedNotesId}
              onToggle={toggleNotes}
            />
          </td>
          <td>
            <LeadStatusActions
              kind="contact"
              entryId={lead._id}
              onUpdate={updateLeadStatus}
            />
          </td>
        </tr>
        {#if expandedNotesId === lead._id}
          <LeadNotesRow {notes} colSpan={6} />
        {/if}
      {:else}
        <tr><td colspan="6">No contact leads yet.</td></tr>
      {/each}
    </tbody>
  </table>
</div>
